/**
 * Retourne la classe CSS d'urgence selon le nombre de jours restants.
 *
 * @param {number|null} n - jours jusqu'au départ (négatif = passé, 0 = aujourd'hui)
 * @returns {'today'|'hot'|'warm'|'soon'|'ok'|'muted'}
 */
export function daysClass(n) {
  if (n === null || n === undefined) return 'muted';
  if (n <= 0) return 'today';
  if (n <= 3) return 'hot';
  if (n <= 7) return 'warm';
  if (n <= 14) return 'soon';
  return 'ok';
}
